import Sites from '../components/views/site/Sites.vue'
import SiteCreate from '../components/views/site/SiteCreate.vue'
import SiteDetail from '../components/views/site/SiteDetail.vue'

const routes = [{
        path: 'location',
        component: Sites,
        name: 'Sites',
        meta: {
            description: 'List of Think Gas Locations',
            title: 'Locations',
            requiresAuth: true
        }
    },

    {
        path: 'location/create',
        component: SiteCreate,
        name: 'SiteCreate',
        meta: {
            description: 'Add a new location',
            title: 'Add Location',
            requiresAuth: true
        }
    },
    {
        path: '/location/:_id',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' ? next({ name: 'SiteCreate' }) : next()
        },
        component: SiteDetail,
        name: 'SiteDetail',
        meta: {
            description: 'Details for the selected Location',
            title: 'Update Location',
            requiresAuth: true
        }
    },
]

export default routes


// WEBPACK FOOTER //
// ./src/routes/sites.route.js